<template>
  <div>
    <el-drawer
      :visible.sync="drawer"
      title="消息通知"
      size="50%"
      @close="closeDrawer"
    >
      <div class="news-container" v-loading="loading">
        <el-timeline>
          <el-timeline-item
            placement="top"
            v-for="(activity, index) in data"
            :key="index"
            :timestamp="moment(activity.CreateTime).format('YYYY-MM-DD HH:mm')"
          >
            <el-badge
              is-dot
              class="item-badge"
              style="width: 100%"
              :hidden="activity.SupplierStaus != 0"
            >
              <el-card class="message-card" :class="{ 'is-expanded': isExpanded(activity) }">
                <div class="message-header" @click="toggleExpand(activity)">
                  <h4>
                    <span style="font-size: 14px">项目名称：</span
                    >{{ activity.ProjectName }}
                  </h4>
                  <el-tag
                    :type="activity.SupplierStaus == 0 ? 'danger' : 'info'"
                    size="mini"
                  >
                    {{ activity.SupplierStaus == 0 ? '未读' : '已读' }}
                  </el-tag>
                  <i
                    class="el-icon-arrow-right header-arrow"
                    :class="{ open: isExpanded(activity) }"
                  ></i>
                </div>
                <transition name="message-collapse">
                  <div
                    v-show="isExpanded(activity)"
                    class="message-body"
                  >
                    <template v-if="getMissingEquipment(activity).list.length">
                      <div class="missing-equipment-title">
                        {{ getMissingEquipment(activity).title }}：
                      </div>
                      <div class="missing-equipment-list">
                        <span
                          v-for="(item, idx) in getMissingEquipment(activity).list"
                          :key="item + idx"
                        >
                          {{ item }}
                        </span>
                      </div>
                    </template>
                    <template v-else>
                      <el-button
                        type="text"
                        v-if="activity.InforType == 1"
                        @click.native="openView(activity)"
                        >{{ activity.Content }}</el-button
                      >
                      <p v-else>{{ activity.Content }}</p>
                    </template>
                    <div class="message-actions" v-if="activity.SupplierStaus == 0">
                      <el-button type="text" @click="markAsRead(activity, { refresh: false })"
                        >标记已读</el-button
                      >
                    </div>
                  </div>
                </transition>
              </el-card>
            </el-badge>
          </el-timeline-item>
        </el-timeline>
        <el-empty description="暂无数据" v-if="data.length == 0"></el-empty>
      </div>

      <el-pagination
        class="pagination-container"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="pagination.pageSizes"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </el-drawer>
    <TemplateFormInfo ref="TemplateFormInfo"></TemplateFormInfo>
  </div>
</template>

<script>
import moment from 'moment'
import TemplateFormInfo from './TemplateFormInfo.vue'
export default {
  data() {
    return {
      moment,
      drawer: false,
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
        pageSizes: [20, 40, 80, 100],
      },
      data: [],
      userId: '',
      ProjectId: '',
      expandedIds: [],
    }
  },
  components: { TemplateFormInfo },
  computed: {},
  methods: {
    parseMissingEquipment(content = '') {
      const result = {
        title: '下面的设备资料未进行上报',
        list: [],
        text: '',
      }
      if (!content) return result
      let text = content.trim()
      text = text.replace(/^通知[:：]\s*/g, '')
      const titleMatch = text.match(/^(下面的设备资料未进行上报)[：:：]/)
      if (titleMatch) {
        result.title = titleMatch[1]
        text = text.slice(titleMatch[0].length).trim()
      }
      text = text.replace(/设备分类未填写信息[。\.]?$/g, '').trim()
      const blacklist = ['设备分类', '设备分类未填写信息', '通知']
      const list = text
        .split(/[,，]/)
        .map((item) => item.trim())
        .filter((item) => item && !blacklist.includes(item))
      result.list = list
      result.text = list.join('，')
      return result
    },
    getMissingEquipment(activity) {
      if (!activity) {
        return { title: '下面的设备资料未进行上报', list: [], text: '' }
      }
      if (activity._missingEquipment) {
        return activity._missingEquipment
      }
      const parsed = this.parseMissingEquipment(activity.Content || '')
      this.$set(activity, '_missingEquipment', parsed)
      return parsed
    },
    async openView(row) {
      let res = null
      let obj = null
      try {
        res = await this.$http.post(
          `/Device_TypeWork/Device_TypeTemplate/GetDeviceInfo?deviceId=${row.deviceId}`,
          {}
        )
        if (res.Success) {
          obj = res.Data
        } else {
          this.$notify.error(res.Msg)
          return
        }
      } catch (error) {
        this.$notify.error(res.Msg)
        return
      }
      if (obj.Id) {
        this.$refs.TemplateFormInfo.openDrawer(
          //树ID
          row.DeviceType,
          //项目ID
          row.ProjectId,
          //this.base_Supplier.Id 供应商ID
          row.SupplierId,
          //设备ID
          row.deviceId,
          //设备名称
          row.DeviceTypeName,
          obj.Status == 0 || obj.Status == 4 ? false : true
        )
      } else {
        this.$notify.error('设备数据不存在')
      }
    },
    handleSizeChange(size) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = size
      this.getDataList()
    },
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.getDataList()
    },
    openDrawer(userId, ProjectId) {
      this.drawer = true
      this.userId = userId
      this.ProjectId = ProjectId
      this.data = []
      this.pagination.currentPage = 1
      this.getDataList()
    },
    closeDrawer() {
      this.drawer = false
    },
    getDataList() {
      this.loading = true
      this.$http
        .post(
          '/Operation_Manage/Operation_Notify/GetSupplierSideOperationNotifyList',

          {
            PageIndex: this.pagination.currentPage,
            PageRows: this.pagination.pageSize,
            SortField: 'CreateTime',
            SortType: 'desc',
            Search: [
              {
                Condition: 'ProjectId',
                Keyword: this.ProjectId,
              },
              {
                Condition: 'SupplierId',
                Keyword: this.userId,
              },
              {
                Condition: 'Type',
                Keyword: 1,
              },
            ],
          }
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.data = res.Data
            this.pagination.total = res.Total
            this.expandedIds = (res.Data || [])
              .filter((item) => item.SupplierStaus === 0)
              .map((item) => item.Id)
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    isExpanded(activity) {
      if (!activity) return false
      return this.expandedIds.includes(activity.Id)
    },
    toggleExpand(activity) {
      if (!activity) return
      const isOpen = this.isExpanded(activity)
      if (isOpen) {
        this.expandedIds = this.expandedIds.filter((id) => id !== activity.Id)
      } else {
        this.expandedIds = [...this.expandedIds, activity.Id]
        if (activity.SupplierStaus === 0) {
          this.markAsRead(activity, { refresh: false })
        }
      }
    },
    markAsRead(activity, options = { refresh: true }) {
      if (activity.SupplierStaus !== 0) {
        return
      }

      this.loading = true
      this.$http
        .post(
          '/Operation_Manage/Operation_Notify/SaveSupplierSideOperationNotify',
          {
            id: activity.Id,
          }
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            activity.SupplierStaus = 1 // 更新本地状态
            this.$notify.success('标记已读')
            this.expandedIds = this.expandedIds.filter((id) => id !== activity.Id)
            if (options.refresh !== false) {
              this.getDataList() // 刷新列表
            }
          } else {
            this.$notify.error(res.Msg || '操作失败')
          }
        })
        .catch((err) => {
          console.error('请求错误:', err)
          this.loading = false
          this.$notify.error('操作失败')
        })
    },
  },
  watch: {
    drawer(newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.news-container {
  padding: 20px;
  height: calc(100vh - 140px);
  box-sizing: border-box;
  overflow-y: auto;
  .el-timeline-item {
    .message-card {
      .message-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;

        h4 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          flex: 1;
        }
        .header-arrow {
          transition: transform 0.2s ease;
          color: #909399;
        }
        .header-arrow.open {
          transform: rotate(90deg);
        }
      }

      .message-body {
        border-top: 1px solid #f2f2f2;
        padding-top: 12px;
        margin-top: 8px;

        p {
          margin: 0;
          color: #666;
          font-size: 14px;
          line-height: 1.6;
        }
        .message-actions {
          margin-top: 10px;
          text-align: right;
        }
      }
      .missing-equipment-title {
        font-weight: 600;
        margin-bottom: 8px;
        color: #f56c6c;
        font-size: 14px;
      }
      .missing-equipment-list {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 6px 12px;
        color: #606266;
        font-size: 13px;
      }
      .missing-equipment-list span {
        display: block;
        word-break: break-all;
        line-height: 1.4;
      }
      .missing-equipment-list span::before {
        content: '\2022';
        display: inline-block;
        margin-right: 4px;
        color: #f56c6c;
      }
    }
  }
}
.pagination-container {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: right;
  margin-top: 10px;
  padding-right: 20px;
}
::v-deep .item-badge .el-badge__content {
  right: 10px !important;
  top: -1px !important;
  width: 10px !important;
  height: 10px !important;
}
.message-collapse-enter-active,
.message-collapse-leave-active {
  transition: all 0.2s ease;
}
.message-collapse-enter,
.message-collapse-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
</style>
